import {ThreeDotsVertical} from "react-bootstrap-icons";
import cx from "classnames";
import React, {MouseEvent, useRef, useState} from "react";
import {Dropdown} from "react-bootstrap";
import {useCloseOutsideClick} from "fearless-common-ui";

interface DotsMenuProps {
 options: Array<{
   label: string | React.ReactNode,
   onClick: (e: MouseEvent<HTMLElement>) => void;
 }>;
 icon?: React.ReactNode;
}

/**
 * Opens a dropdown menu via an icon. Usually the typical three vertical dots.
 */
export default function DotsMenu({ options, icon = undefined }: DotsMenuProps) {
    const [open, setOpen] = useState(false);
    const ref = useRef<HTMLSpanElement>(null);

    // Hide on click outside, so only one DotsMenu is open at all times.
    useCloseOutsideClick({ ref, callback: () => { setOpen(false); }});

    return (
        <span className="position-relative" ref={ref}>
            <button
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setOpen(true);
                }}
                className="bg-transparent border-0"
            >
                {icon || <ThreeDotsVertical />}
            </button>
            <Dropdown
                show={open}
                onToggle={() => setOpen(false)}
            >
                <Dropdown.Menu className="position-absolute end-0 py-0 border-neutral-300 rounded-0 shadow-lg">
                    {options.map(({ label, onClick }, idx) => (
                        <Dropdown.Item
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                e.persist();
                                onClick(e);
                            }}
                            key={idx}
                            className={cx({
                                "py-3": true,
                                "border-top border-neutral-300": idx >= 1,
                            })}
                        >
                          <div style={{ minWidth: '220px' }}>{label}</div>
                        </Dropdown.Item>
                    ))}
                </Dropdown.Menu>
            </Dropdown>
        </span>
    )
}
